import React from 'react'
import Footer from './Footer'

const MainContent = ({children}) => {
  return (
    <main className='col-md-9 ml-sm-auto col-lg-10 px-md-4 py-4' style={{ marginLeft: '250px', width: 'calc(100vw - 250px'}}>
        {children}
        <Footer />
    </main>
  )
}

export default MainContent